import { useMemo } from 'react';

/**
 * Generates image title from vehicle data and labels.
 * Returns the imgAttributes title if available, otherwise constructs from vehicle fields.
 */
const useImageTitle = ({ vehicle, labels }) => {
	const {
		make,
		year,
		model,
		bodyStyle,
		trim,
		type,
		certified,
		imgAttributes
	} = vehicle;

	const imgTitle = useMemo(() => {
		if (imgAttributes) {
			return imgAttributes?.imageTitle;
		}
		const typeTerm = type ? labels.get(certified ? 'CERTIFIED' : type) : '';
		const typeTermCapitalCase = typeTerm
			? typeTerm[0].toUpperCase() + typeTerm.substr(1).toLowerCase()
			: '';
		return `${typeTermCapitalCase} ${year} ${make} ${model} ${trim} ${bodyStyle}`.trim();
	}, [
		make,
		year,
		model,
		bodyStyle,
		trim,
		type,
		certified,
		imgAttributes,
		labels
	]);

	return imgTitle;
};

export default useImageTitle;
